import { RuntimeMediaQuery } from '@duda-co/responsive-styles/RuntimeMediaQuery';
import type { ResponsiveStylesStructured } from '@duda-co/responsive-styles/types/ResponsiveStylesTypes';

export const containerDefaultStyles: ResponsiveStylesStructured = {
    [RuntimeMediaQuery.COMMON]: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        cursor: 'auto',
    },
};

export const fileListDefaultStyles: ResponsiveStylesStructured = {
    [RuntimeMediaQuery.COMMON]: {
        marginBlockStart: '8px',
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
        width: '100%',
    },
};

export const fileItemDefaultStyles: ResponsiveStylesStructured = {
    [RuntimeMediaQuery.COMMON]: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '15px',
        backgroundColor: '#ffffff',
        border: '1px solid #E4E4E6',
        borderRadius: '12px',
        gap: '12px',
    },
};

export const fileInfoDefaultStyles: ResponsiveStylesStructured = {
    [RuntimeMediaQuery.COMMON]: {
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        flex: '1',
        minWidth: '0',
    },
};

export const fileIconDefaultStyles: ResponsiveStylesStructured = {
    [RuntimeMediaQuery.COMMON]: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'transparent',
        borderRadius: '4px',
        flexShrink: '0',
    },
};

export const fileInfoContentDefaultStyles: ResponsiveStylesStructured = {
    [RuntimeMediaQuery.COMMON]: {
        display: 'flex',
        flexDirection: 'column',
        gap: '4px',
        minWidth: '0',
        flex: '1',
    },
};

export const fileNameDefaultStyles: ResponsiveStylesStructured = {
    [RuntimeMediaQuery.COMMON]: {
        fontSize: '14px',
        color: 'rgba(45, 46, 50, 1)',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        lineHeight: '1.2',
        minWidth: '0',
        width: '100%',
    },
};

export const fileSizeDefaultStyles: ResponsiveStylesStructured = {
    [RuntimeMediaQuery.COMMON]: {
        fontSize: '12px',
        color: '#64696B',
    },
};

export const removeButtonDefaultStyles: ResponsiveStylesStructured = {
    [RuntimeMediaQuery.COMMON]: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '0px',
        backgroundColor: 'transparent',
        color: '#5D6068',
        border: 'none',
        borderRadius: '4px',
        cursor: 'pointer',
        transition: 'color 0.2s ease',
        outline: 'none',
    },
};

export const removeButtonHoverDefaultStyles: ResponsiveStylesStructured = {
    [RuntimeMediaQuery.COMMON]: {
        color: 'hsla(223, 3%, 59%, 1)',
    },
};

export const errorDefaultStyles: ResponsiveStylesStructured = {
    [RuntimeMediaQuery.COMMON]: {
        fontSize: '12px',
        color: '#dc3545',
        marginTop: '4px',
    },
};
